import {Component, Input, OnInit} from '@angular/core';
import {DataGridActionButtonDef} from "../../../models/data-grid-action-button-def.model";
import {PopoverController} from "@ionic/angular";
import {CommonUtils} from "../../../utils/common";

@Component({
  selector: 'app-data-grid-action-buttons-menu',
  templateUrl: './data-grid-action-buttons-menu.component.html',
  styleUrls: ['./data-grid-action-buttons-menu.component.scss'],
})
export class DataGridActionButtonsMenuComponent implements OnInit {

  @Input() actionButtonsDef: DataGridActionButtonDef[];
  @Input() data: any;
  @Input() standaloneMode: boolean;

  constructor(
    private popoverController: PopoverController,
    public commonUtils: CommonUtils
  ) { }

  ngOnInit() {}

  handleButtonClick(ev: any, actionButton: DataGridActionButtonDef, data: any) {
    if (actionButton.actionConfirmationQuestion) {
      this.commonUtils.presentYesNoActionSheet(actionButton.actionConfirmationQuestion, 'Tak', 'Nie', 'checkmark', 'close', () => {
        actionButton.action(data);
      }, () => {
      }).then(() => {});
    } else {
      actionButton.action(data);
    }

    ev.stopPropagation();

    this.popoverController.dismiss().then(r => {
    });
  }

  isEnabled(actionButton: DataGridActionButtonDef) {
    if(this.standaloneMode) {
      return actionButton.isEnabled(this.data);
    }
    if (this.data.get('deleted') !== undefined &&  this.data.get('deleted') !==null && !actionButton.enabledForDeletedObjects) return false;
    else return actionButton.isEnabled(this.data)
  }
}
